import { motion } from "framer-motion"
import {Monitor, Layers, PenTool, Bot, Video, HelpCircle, Users, Smartphone} from 'lucide-react'

const resources = [
  { icon: <Monitor className="w-6 h-6" />, text: "Acesso completo à plataforma EW Pass" },
  { icon: <Layers className="w-6 h-6" />, text: "Aulas organizadas por nível" },
  { icon: <PenTool className="w-6 h-6" />, text: "Exercícios práticos" },
  { icon: <Bot className="w-6 h-6" />, text: "Lucy IA, nossa tutora 24 horas por WhatsApp" },
  { icon: <Video className="w-6 h-6" />, text: "Aulas ao vivo semanais" },
  { icon: <HelpCircle className="w-6 h-6" />, text: "Plantão com professores reais" },
  { icon: <Users className="w-6 h-6" />, text: "Comunidade ativa" },
  { icon: <Smartphone className="w-6 h-6" />, text: "App para estudar em qualquer lugar" },
]

export default function WhatYouGet() {
  return (
    <section className="bg-white py-16 md:py-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-serif-display text-3xl md:text-4xl font-bold text-blue-900 text-center mb-12"
        >
          Tudo que você precisa para sair do básico:
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
          {resources.map((r, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="flex items-center gap-4 bg-blue-50 rounded-xl p-4 border border-blue-100 hover:bg-blue-100 transition-colors duration-200"
            >
              <div className="w-12 h-12 bg-blue-600 text-white rounded-xl flex items-center justify-center flex-shrink-0">
                {r.icon}
              </div>
              <p className="text-blue-900 font-medium">{r.text}</p>
            </motion.div>
          ))}
        </div>

        {/* Ancoragem de valor */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-gradient-to-r from-blue-50 to-red-50 rounded-2xl p-8 text-center border border-blue-100"
        >
          <p className="text-gray-600 text-lg mb-3">
            Quanto você gastaria em um curso tradicional ao mês{" "}
            <span className="line-through text-red-500 font-semibold">R$ 350,00</span>.
          </p>
          <p className="text-gray-600 text-lg mb-3">
            E tem ainda as taxas de matrícula e material didático, em média{" "}
            <span className="line-through text-red-500 font-semibold">R$ 600 a cada seis meses</span>.
          </p>
          <p className="text-blue-900 text-xl font-bold mt-4">
            Aqui você investe menos do que muitas pessoas gastam em delivery em um fim de semana.
          </p>
        </motion.div>
      </div>
    </section>
  )
}
